import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import WhyChooseSection from "./components/WhyChooseSection";
import BestSellersSection from "./components/BestSellersSection";
import CustomBoxSection from "./components/CustomBoxSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f5ede0]">
      <Navbar />
      <HeroSection />
      <CategoriesSection />
      <WhyChooseSection />
      <BestSellersSection />
      <CustomBoxSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}